function flattenTree(tree) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let indent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let {
    childrenKey = "items",
    indentKey = "indent"
  } = options;
  let items = [];
  tree.forEach(item => {
    items.push({
      ...item,
      [indentKey]: indent
    });
    if (item[childrenKey]) {
      items = items.concat(flattenTree(item[childrenKey], options, indent + 1));
    }
  });
  return items;
}
export { flattenTree as default };